import type { BrandStoragePool } from '@/types/package';

/**
 * Single rule for "this brand is at / over its included storage, but the Brand Portfolio pool still has room":
 * used by Settings, the Media Library bar and the over-limit banner so they never disagree with the upload check.
 * Strict: the pool must have room left (poolMb > poolUsedMb); a brand exactly at its limit with an empty or full
 * pool is NOT covered (it shows the upgrade hint). Standalone brands (no pool) are never covered.
 */
export function storageCoveredByPool(usedMb: number, limitMb: number | null, pool: BrandStoragePool | undefined): boolean {
  if (!pool || limitMb === null || limitMb <= 0) return false;
  return usedMb >= limitMb && pool.poolMb - pool.poolUsedMb > 0;
}
